parseEnumValueName